import React from 'react';

import { PAGE_TYPES } from '@dashboard/enums/page-types';

import AdminChargesList from '@dashboard/admin/components/AdminChargesList';

const Payments = () => (
  <AdminChargesList
    pageType={PAGE_TYPES.CHECKOUT}
    titleHeader="Checkout"
    getTitle={charge => charge.product?.title || charge.page?.title}
    testFilterLabel="Include test payments"
    emptyStateTitle="No payments found"
    viewLabel="View payment"
    viewPath="/payments"
  />
);

export default Payments;
